import * as React from "react";
const SvgPlayFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.403 10.362a2 2 0 0 1 0 3.277l-7.256 5.079A2 2 0 0 1 7 17.079V6.921a2 2 0 0 1 3.147-1.639z", clipRule: "evenodd" }));
export default SvgPlayFill;
